// removed by extract-text-webpack-plugin
module.exports = {"panel":"SubmissionPanel__panel___2ugj6 layout__panel___vsQZV","headerContainer":"SubmissionPanel__headerContainer___2o0Tc","body":"SubmissionPanel__body___3PfQ2","menuContainer":"SubmissionPanel__menuContainer___2WLSX","panelContainer":"SubmissionPanel__panelContainer___38sxE"};


//////////////////
// WEBPACK FOOTER
// ./src/submission/components/SubmissionPanel.css
// module id = 767
// module chunks = 0